import classNames from "classnames";
import { PropsWithChildren } from "react";

interface DrawerContentProps extends PropsWithChildren {
    className?: string;
}

export const DrawerContent = ({ children, className }: DrawerContentProps) => {
    return <div className={classNames("bg-gray-100 rounded-lg border-dashed border", className)}>{children}</div>;
};
